import type { BadgeVariant } from './display';

const STATUS_VARIANTS: Record<string, BadgeVariant> = {
  draft: 'gray',
  pending: 'gray',
  queued: 'gray',
  archived: 'gray',
  inactive: 'gray',
  deactivated: 'gray',

  active: 'success',
  approved: 'success',
  ready: 'success',
  success: 'success',
  complete: 'success',
  completed: 'success',
  published: 'success',
  live: 'success',

  generating: 'warning',
  in_progress: 'warning',
  processing: 'warning',
  uploading: 'warning',
  rendering: 'warning',
  review: 'warning',
  scheduled: 'warning',
  ytreview: 'warning',
  invited: 'warning',

  rejected: 'error',
  failed: 'error',
  timed_out: 'error',
  error: 'error',
};

/** Returns the badge variant of a status; an unknown status is gray. */
export function statusBadgeVariant(status: string): BadgeVariant {
  return STATUS_VARIANTS[status] ?? 'gray';
}
